import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import moment from 'moment';
import { computed, inject } from 'vue';
import type { Translator } from 'types/injects/translator.type';


export default /*@__PURE__*/_defineComponent({
  __name: 'ExportProgressColumn',
  props: {
    status: {
        type: String,
        required: true,
    },
    progress: {
        type: Number,
        required: false,
        default: 0,
    },
    started_at: {
        type: Object,
        required: false,
    },
},
  setup(__props) {

const $t = inject('$t') as Translator;

const props = __props;

// Ajout de la méthode d'estimation
const estimatedRemainingTime = computed(() => {
    if (!props.started_at || !props.progress || props.progress <= 0) return null;
    const now = moment();
    const started = moment(props.started_at);
    const elapsed = now.diff(started, 'seconds');
    if (elapsed <= 0) return null;
    const total = elapsed / (props.progress / 100);
    const remaining = Math.round(total - elapsed);
    if (remaining <= 0) return null;

    if (remaining < 60) {
        return $t.__('export.progress.remainingSeconds', { remaining });
    } else {
        return $t.__('export.progress.remainingMinutes', { remaining: Math.round(remaining / 60) });
    }
});

const progressBarCaption = computed(() => {
    if (props.status === 'pending') {
        return $t.__('export.progress.pending');
    }
    if (props.status === 'succeed') {
        return $t.__('export.progress.succeed');
    }
    if (props.status === 'failed') {
        return $t.__('export.progress.failed');
    }
    if (props.status === 'ongoing') {
        // Ajout estimation si progress > 0
        const estimation = estimatedRemainingTime.value;
        if (estimation) {
            return estimation;
        }
        return $t.__('export.progress.estimating');
    }
    return props.status;
});

return (_ctx: any,_cache: any) => {
  const _component_CompassProgressBar = _resolveComponent("CompassProgressBar")!
  const _component_CompassPill = _resolveComponent("CompassPill")!

  return (__props.status !== 'failed')
    ? (_openBlock(), _createBlock(_component_CompassProgressBar, {
        key: 0,
        state: __props.progress >= 0 ? __props.progress : 0,
        caption: progressBarCaption.value,
        type: _ctx.CompassEnums.ProgressBarType.COLORED,
        lowLimit: 0,
        highLimit: 100,
        class: _normalizeClass({ 'progress-infinite': __props.progress < 0 })
      }, null, 8 /* PROPS */, ["state", "caption", "type", "class"]))
    : (_openBlock(), _createBlock(_component_CompassPill, {
        key: 1,
        label: progressBarCaption.value,
        icon: "close",
        color: _ctx.CompassEnums.PillColor.RED
      }, null, 8 /* PROPS */, ["label", "color"]))
}
}

})